import * as React from "react";
const SvgFiRrBudget = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-budget_svg__a)">
      <path
        fill="#062147"
        d="M17.5 7.5a1 1 0 0 0 .707-.293l.629-.629A3.5 3.5 0 0 0 20.5 7C22.43 7 24 5.43 24 3.5S22.43 0 20.5 0 17 1.57 17 3.5c0 .602.153 1.169.422 1.664l-.629.629A.999.999 0 0 0 17.5 7.5m3-5.5c.827 0 1.5.673 1.5 1.5S21.327 5 20.5 5a1.501 1.501 0 0 1 0-3m0 15c-.602 0-1.169.153-1.664.422l-.629-.629a.999.999 0 1 0-1.414 1.414l.629.629A3.5 3.5 0 0 0 17 20.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5m0 5a1.501 1.501 0 1 1 1.5-1.5c0 .827-.673 1.5-1.5 1.5M6.578 5.164A3.5 3.5 0 0 0 7 3.5C7 1.57 5.43 0 3.5 0S0 1.57 0 3.5 1.57 7 3.5 7c.602 0 1.169-.153 1.664-.422l.629.629a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414zM3.5 5C2.673 5 2 4.327 2 3.5S2.673 2 3.5 2 5 2.673 5 3.5 4.328 5 3.5 5m2.293 11.793-.629.629A3.5 3.5 0 0 0 3.5 17C1.57 17 0 18.57 0 20.5S1.57 24 3.5 24 7 22.43 7 20.5c0-.602-.153-1.169-.422-1.664l.629-.629a.999.999 0 1 0-1.414-1.414M3.5 22c-.827 0-1.5-.673-1.5-1.5S2.673 19 3.5 19a1.501 1.501 0 0 1 0 3M10 10c0 .378.271.698.644.76l3.041.507A2.76 2.76 0 0 1 16 14c0 1.654-1.346 3-3 3v1a1 1 0 1 1-2 0v-1.002h-.27a3.01 3.01 0 0 1-2.596-1.496 1 1 0 0 1 1.73-1.003c.179.308.51.499.866.499L13 15a1 1 0 0 0 .999-1 .77.77 0 0 0-.644-.76l-3.041-.507A2.76 2.76 0 0 1 7.999 10c0-1.654 1.346-3 3-3V6a1 1 0 1 1 2 0v1.003h.271c1.063 0 2.058.573 2.594 1.495a1 1 0 1 1-1.728 1.005 1 1 0 0 0-.866-.5L10.999 9A1 1 0 0 0 10 10"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-budget_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBudget;
